import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NotificationsResponse } from '../interfaces/notification.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  public constructor(private readonly api: ApiService) {}

  public list(): Observable<NotificationsResponse> {
    return this.api.get<NotificationsResponse>('me/notifications');
  }

  public markRead(id: string): Observable<object> {
    return this.api.post(
      `me/notifications/${encodeURIComponent(id)}/mark-read`,
      {},
    );
  }

  public markAllRead(ids: string[]): Observable<NotificationsResponse> {
    return this.api.post<NotificationsResponse, { ids: string[] }>(
      'me/notifications/mark-read',
      { ids },
    );
  }
}
